import axios from "axios"

export const getCCLists = async (accountId) => {
	return (await axios.get(`${process.env.REACT_APP_CONSTANT_CONTACT_ENDPOINT}/get-lists/${accountId}`)).data
}